import React, { useState } from 'react';
import { Tab, Tabs, Typography } from '@mui/material';
import { TabContent } from './TabContent';
import { TimeRangeTabContent } from './TimeRangeContent';
import { Terminal, SnapshotUrl, ShippingLine, ContainerType } from '../../../types/Shipping';
import { PerDiem } from './TimeRangeContent/types';

interface Props {
  perDiem: Record<string, PerDiem[]>;
  ports: Terminal[];
  snapshotUrls: SnapshotUrl[];
  shippingLines: ShippingLine[];
  containerTypes: ContainerType[];
}

export const TimeRangeTerminalTabs: React.FC<Props> = (props) => {
  const { perDiem, ports, snapshotUrls, shippingLines, containerTypes } = props;

  const tabs = snapshotUrls
    ? snapshotUrls.map(({ terminal }) => {
        const port = ports.find(({ key }) => key === terminal);
        const { pier } = port || {};
        return {
          key: terminal,
          pier,
        };
      })
    : [];

  const [selectedTab, setSelectedTab] = useState(tabs[0]?.key);

  if (snapshotUrls.length === 0) return null;
  if (ports.length === 0) return null;

  const timeRangeTab = perDiem[selectedTab];
  const singleTab = snapshotUrls.find(({ terminal }) => terminal === selectedTab);

  return (
    <div>
      <Tabs value={selectedTab} onChange={(event, value) => setSelectedTab(value)}>
        {tabs.map(({ key, pier }) => (
          <Tab key={key} disableRipple label={<Typography>{pier}</Typography>} value={key} />
        ))}
      </Tabs>
      {timeRangeTab && (
        <TimeRangeTabContent
          key={selectedTab}
          shippingLines={shippingLines}
          containerTypes={containerTypes}
          perDiem={timeRangeTab}
          snapshotUrl={snapshotUrls.find((s) => s.terminal === selectedTab)}
          terminal={ports.find((p) => p.key === selectedTab)}
        />
      )}
      {!timeRangeTab && singleTab && (
        <TabContent
          key={selectedTab}
          snapshotUrl={singleTab}
          terminal={ports.find((p) => p.key === selectedTab)}
        />
      )}
    </div>
  );
};
